module.exports = __webpack_public_path__ + "static/media/covidbg.21b57568.jpg";